import { forwardRef } from 'react'

import type { Props as IDateInputProp } from '../../Basic/DateInput'
import type { ReactElement, ReactNode } from 'react'
import type { Props as SelectProps } from 'react-select'

import BasicDateInput from '../../Basic/DateInput'
import Wrapper from '../Wrapper'

interface Props extends IDateInputProp {
  defaultValue?: any
  error?: ReactNode
  focus?: boolean
  label?: string
}

const DateInput = forwardRef(({ className, error, ...props }: Props & SelectProps): ReactElement => {
  return (
    <Wrapper className={className} error={error}>
      <BasicDateInput {...props} dateValue={props.value as string} />
    </Wrapper>
  )
})

DateInput.displayName = 'DateInput'

export default DateInput
